import React from "react";
import { withTranslation, type WithTranslation } from "react-i18next";
import { Button, Form, FormField, Select, TextInput } from "../ui";

export interface DocumentLibraryFilters {
  search: string;
  year: string;
  format: string;
}

export interface DocumentLibraryAvailableFilters {
  years: Array<string | number>;
  formats: Array<string>;
}

interface DocumentLibraryFilterProps extends WithTranslation {
  availableFilters: DocumentLibraryAvailableFilters;
  filters: DocumentLibraryFilters;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onReset: () => void;
}

function DocumentLibraryFilter({
  t,
  filters,
  availableFilters,
  onChange,
  onReset,
}: DocumentLibraryFilterProps) {
  return (
    <Form
      className="DocumentLibraryFilterPanel filters-sidebar"
      aria-labelledby="DocumentLibraryFilter-title"
    >
      <h4 id="DocumentLibraryFilter-title">{t("document_library.filters.title")}</h4>

      <FormField
        className="filter-group"
        label={t("document_library.filters.search")}
        htmlFor="documentLibrarySearch"
      >
        <TextInput
          id="documentLibrarySearch"
          className="DocumentLibraryFilterInput"
          name="search"
          value={filters.search}
          onChange={onChange}
          placeholder={t("document_library.filters.search_placeholder")}
        />
      </FormField>

      <FormField
        className="filter-group"
        label={t("document_library.filters.year")}
        htmlFor="documentLibraryYear"
      >
        <Select
          id="documentLibraryYear"
          className="DocumentLibraryFilterInput"
          name="year"
          value={filters.year}
          onChange={onChange}
          options={[
            { value: "", label: t("document_library.filters.all_years") },
            ...(availableFilters.years || []).map((year) => ({ value: year, label: year })),
          ]}
        />
      </FormField>

      <FormField
        className="filter-group"
        label={t("document_library.filters.format")}
        htmlFor="documentLibraryFormat"
      >
        <Select
          id="documentLibraryFormat"
          className="DocumentLibraryFilterInput"
          name="format"
          value={filters.format}
          onChange={onChange}
          options={[
            { value: "", label: t("document_library.filters.all_formats") },
            ...(availableFilters.formats || []).map((format) => ({
              value: format,
              label: String(format).toUpperCase(),
            })),
          ]}
        />
      </FormField>

      <div className="DocumentLibraryFilterActions">
        <Button variant="secondary" className="DocumentLibraryResetButton" onClick={onReset}>
          {t("document_library.filters.reset")}
        </Button>
      </div>
    </Form>
  );
}

export default withTranslation()(DocumentLibraryFilter);
